
import Vue from "vue";
import BaseButton from "@/components/buttons/BaseButton.vue";

export default Vue.extend({
  components: {BaseButton},
  props: {
    Headline: String,
    Errors: {
      type: [String, Array]
    },
    Error: {
      default: "",
      type: String
    },
    ButtonConfirm: String,
  },
  data: function () {
    return {
      isActive: false,
    };
  },
  methods: {
    OnScroll() {
    },
    Show: function () {
      this.isActive = true;
    },
    Hide: function () {
      this.isActive = false;
    },
    Confirm: function () {
      this.$emit("Confirm");
      this.Hide();
    },
  },
});
